/**
 * SecureStoragePage — Settings → Secure Storage.
 *
 * The user-facing explainer for the keybook trust model. Since the
 * SSE refactor there is no per-user keypair to manage on this page,
 * so it's purely informational.
 */
import { useTranslation } from '@papan/i18n'
import { ShieldCheck, BookKey, Eye, History } from 'lucide-react'

interface SecureStoragePageProps {
  userId?: string
}

export function SecureStoragePage(_props: SecureStoragePageProps) {
  const { t } = useTranslation('keybook')
  return (
    <div className="flex-1 themed-bg-primary p-6 overflow-y-auto">
      <div className="max-w-2xl">
        <h1 className="text-xl font-semibold themed-text mb-4">
          {t('secureStorage.title')}
        </h1>
        <div className="space-y-4">
          <section className="themed-bg-secondary rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2">
              <ShieldCheck size={18} className="text-emerald-500" />
              <h2 className="themed-text font-medium">{t('secureStorageEncryptionTitle')}</h2>
            </div>
            <p className="text-sm themed-text-secondary">{t('secureStorageEncryptionBody')}</p>
          </section>

          <section className="themed-bg-secondary rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2">
              <Eye size={18} className="themed-icon" />
              <h2 className="themed-text font-medium">{t('secureStorageAccessTitle')}</h2>
            </div>
            <p className="text-sm themed-text-secondary">{t('secureStorageAccessBody')}</p>
          </section>

          <section className="themed-bg-secondary rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2">
              <History size={18} className="themed-icon" />
              <h2 className="themed-text font-medium">{t('secureStorageLogTitle')}</h2>
            </div>
            <p className="text-sm themed-text-secondary">{t('secureStorageLogBody')}</p>
          </section>

          <section className="themed-bg-secondary rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2">
              <BookKey size={18} className="themed-icon" />
              <h2 className="themed-text font-medium">{t('secureStorageManageTitle')}</h2>
            </div>
            <p className="text-sm themed-text-secondary">{t('secureStorageManageBody')}</p>
          </section>
        </div>
      </div>
    </div>
  )
}
